<script>
  import {
    buildNoteIframeSrcdoc,
  } from '@/components/search/email/emailBodyHtml';

  export default {
    name: "NoteExpansion",
    props: {
      colspan: {
        required: true
      },
      files: {
        default: []
      },
      html: {
        type: Boolean,
        default: false,
      },
      nid: {
        required: true
      },
      note: {},
      tasks: {},
      type: {},
      width: '',// 13 Jun 2025 JCH (merged in rebase) - updates width handling
    },
    render(createElement) {
      const normalizedType = String(this.type || '').toLowerCase().trim();
      const webNote = normalizedType === 'web' || normalizedType === 'web in' || normalizedType === 'webin';
      const emailHtmlNote = normalizedType === 'email in' && this.html;
      const iframeNote = webNote || emailHtmlNote;
      let children = [];

      if (this.tasks) {
        let task = createElement('div', {}, [
          createElement('p', {
            attrs: {
              class: 'font-italic',
              width: this.width,// 13 Jun 2025 JCH (merged in rebase) - updates width handling
            },
          }, 'Comments: '),
          createElement('p', {
            domProps:{
              innerHTML:`<div style="color: grey; width: ${this.width} !important; background-color: transparent !important">`
                + this.tasks.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/\uFFFD/g, "'") + '</div><br>'
            }
          })
        ]);
        children.push(task);
      }

      if (this.note) {
        let note;
        if (iframeNote) {
          const srcdoc = emailHtmlNote ? buildNoteIframeSrcdoc(this.note) : this.note;
          note = createElement('div', {}, [createElement('iframe', {
            attrs: {
              srcdoc,
              sandbox: 'allow-same-origin allow-popups allow-popups-to-escape-sandbox',
              title: 'Formatted note body',
            },
            style: {
              width: this.width || '100%',
              height: 'clamp(240px, 40vh, 420px)',
              border: '0',
              display: 'block',
            },
          })]);
        } else {
          note = createElement('div', {
            attrs: {
              class: 'note'
            },
            domProps:{
              innerHTML:`<div style="width: ${this.width} !important; background-color: transparent !important">` + this.note.replace(/\uFFFD/g, "'") + '</div>' // 13 Jun 2025 JCH (merged in rebase) - updates width handling
            }
          });
        }

        children.push(note);
      }

      if (this.files.length) {
        let fileLinks = [];
        fileLinks.push(createElement('br'));// need space here
        this.files.forEach(file => {
            let link = createElement('a', {
              attrs: {
                href: `${process.env.VUE_APP_UW_URL}/download/${file.loidfid}`,
                width: this.width,// 13 Jun 2025 JCH (merged in rebase) - updates width handling
              },
              style: {
                color: 'blue'
              }
            }, `${file.file_description}`);
            fileLinks.push(link, createElement('br'));
        });

        let files = createElement('div', {}, fileLinks);
        children.push(files)
      }

      return createElement('td', {
        attrs: {
          style: 'background-color: #f9f9f9',// 13 Jun 2025 JCH (merged in rebase) slightly lighter than whitesmoke to make expansions easier to spot
          class: 'py-6',
          colspan: this.colspan,// 18 Feb 2026 JCH - use provided table colspan; webColspan is undefined and causes width/layout issues
        }
      }, children);
    },
  }
</script>

<style scoped>
    .note table {
        border-collapse: collapse;
        margin: 0 auto;
        width: auto !important;
    }
    .note table, .note th, .note td, .note tr {
        border: 1px solid black !important;
    }
    .note td {
        padding: 1em;
    }
</style>
